import { TOKEN_KEY } from "@/core/localStorage/AuthTokenLS";
import { USER_KEY, TEAM_KEY } from "@/core/localStorage/UserLS";
import { INVITE_BANNER_DISMISSED_KEY, ASIDE_INVITE_CARD_DISMISSED_KEY } from "@/core/localStorage/AccountLS";
import { LS_CONFIG_NAME_KEY } from "@/stores/config";
import { THEME_MODE_LS_KEY } from "@/stores/theme";

const ls = window.localStorage

/**
 * Every localStorage key the app sets, or has set in earlier versions.
 * Add new keys here when introducing them, so they are cleared on logout.
 */
const APP_STORAGE_KEYS: string[] = [
  // Auth token (current, and the names used by earlier versions)
  TOKEN_KEY,
  "skyflok_token",
  "id_token",

  // Cached User and Team (UserLS)
  USER_KEY,
  TEAM_KEY,

  // Layout config (stores/config) for the current brand, the other brands
  // (they share the origin in local development) and the Metronic demo default
  LS_CONFIG_NAME_KEY,
  "config_ironshard",
  "config_skyflok",
  "config_demo3",

  // Metronic layout builder tab (removed earlier)
  "layoutBuilderTabIndex_demo3",

  // Theme mode (stores/theme, ThemeModeComponent)
  THEME_MODE_LS_KEY,
  "kt_theme_mode_menu",

  // UI language (UserAccountMenu)
  "lang",

  // Email remembered between the password reset request and reset pages
  "password_reset_email",

  // Dismissed "Working with others?" banner on the Account pages (AccountLS)
  INVITE_BANNER_DISMISSED_KEY,

  // Dismissed "Invite your team" card in the sidebar (AccountLS)
  ASIDE_INVITE_CARD_DISMISSED_KEY,
];

/**
 * @description remove every key the app has ever stored in localStorage
 */
export const clearAppStorage = (): void => {
  new Set(APP_STORAGE_KEYS).forEach(key => ls.removeItem(key));
};

export default { clearAppStorage };
